module.exports = __webpack_public_path__ + "static/media/january.fd4e9a79.png";